import { PrintLabelFormat, QZHIDDevice } from './types'
import './textEncoderPolyfill'

/**
 * Given a printer name, returns if it is zebra or not
 * Defaults to PDF if not found
 */
export const detectPrintLabelFormat = (printerName: string): PrintLabelFormat => {
  if (!printerName) return 'PDF'

  const fmtd = printerName.toLowerCase()

  if (fmtd.match('dymo')) return 'PDF'

  if (fmtd.match('zebra')) return 'ZPL'
  if (fmtd.match('zpl')) return 'ZPL'
  if (fmtd.match('zdesigner')) return 'ZPL'
  if (fmtd.match('gk420')) return 'ZPL'
  if (fmtd.match('gx420')) return 'ZPL'

  // "Star TSP743II (STR_T-001)" on Mac
  // "Star TSP700II (TSP743II)" on Windows
  if (fmtd.match('star')) return 'PDF'
  if (fmtd.match('tsp')) return 'PDF'

  return 'PDF'
}

function hex(buffer: ArrayBuffer) {
  const hexCodes = []
  const view = new DataView(buffer)
  for (let i = 0; i < view.byteLength; i += 4) {
    const value = view.getUint32(i)
    const stringValue = value.toString(16)
    const padding = '00000000'
    const paddedValue = (padding + stringValue).slice(-padding.length)
    hexCodes.push(paddedValue)
  }

  return hexCodes.join('')
}

export function sha256(str: string): PromiseLike<string> {
  const buffer = new TextEncoder().encode(str)
  return crypto.subtle.digest('SHA-256', buffer).then(hash => hex(hash))
}

export const isNotableHIDDevice = (d: QZHIDDevice): boolean => {
  if (!d.product) return false
  const product = d.product.toLocaleLowerCase()

  if (product.match(/keyboard|mouse|trackpad/)) return false

  return true
}
